var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod } from "../HttpClient";
/* tslint:disable:no-namespace */
export var FleetOwnerAuthNoAuthService;
(function (FleetOwnerAuthNoAuthService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [VerificationAuthenticationController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/controller/VerificationAuthenticationController.ts)} */
            _this.startAuthentication = function (query, body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/startAuthentication",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query,
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [VerificationAuthenticationController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/controller/VerificationAuthenticationController.ts)} */
            _this.resendVerificationCode = function (query, body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/resendVerificationCode",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query,
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [VerificationAuthenticationController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/controller/VerificationAuthenticationController.ts)} */
            _this.completeAuthentication = function (query, body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/completeAuthentication",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query,
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerPortalController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/src/rides/driver/fleet_owner/main/auth/controller/FleetOwnerPortalController.ts)} */
            _this.startPhoneAuthentication = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/startPhoneAuthentication",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerTokenAuthenticationController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/src/rides/driver/fleet_owner/main/auth/controller/FleetOwnerTokenAuthenticationController.ts)} */
            _this.getAccessToken = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getAccessToken",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [PasswordController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/src/rides/driver/fleet_owner/main/auth/controller/PasswordController.ts)} */
            _this.requestPasswordResetEmail = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/requestPasswordResetEmail",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [PasswordController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/src/rides/driver/fleet_owner/main/auth/controller/PasswordController.ts)} */
            _this.getResetPasswordForm = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getResetPasswordForm",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [PasswordController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/src/rides/driver/fleet_owner/main/auth/controller/PasswordController.ts)} */
            _this.submitResetPasswordForm = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/submitResetPasswordForm",
                            service_id: "fleet-owner-auth",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    FleetOwnerAuthNoAuthService.ApiClient = ApiClientClass;
    /** Generated from: {@link [VerificationAuthenticationController.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/controller/VerificationAuthenticationController.ts)} */
    var AppStore;
    (function (AppStore) {
        AppStore["GOOGLE"] = "google";
        AppStore["APPLE"] = "apple";
        AppStore["HUAWEI"] = "huawei";
    })(AppStore = FleetOwnerAuthNoAuthService.AppStore || (FleetOwnerAuthNoAuthService.AppStore = {}));
    /** Generated from: {@link [VerificationAuthenticationService.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/service/VerificationAuthenticationService.ts)} */
    var AuthResult;
    (function (AuthResult) {
        AuthResult["SUCCESS"] = "success";
        AuthResult["TWO_FACTOR_REQUIRED"] = "two_factor_required";
        AuthResult["PASSWORD_CHANGE_REQUIRED"] = "password_change_required";
    })(AuthResult = FleetOwnerAuthNoAuthService.AuthResult || (FleetOwnerAuthNoAuthService.AuthResult = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = FleetOwnerAuthNoAuthService.BrandEnum || (FleetOwnerAuthNoAuthService.BrandEnum = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/fleet/constants/Types.ts)} */
    var CompanyIdentityType;
    (function (CompanyIdentityType) {
        CompanyIdentityType["HOLDING_FLEET"] = "holding_fleet";
        CompanyIdentityType["FLEET_COMPANY"] = "fleet_company";
    })(CompanyIdentityType = FleetOwnerAuthNoAuthService.CompanyIdentityType || (FleetOwnerAuthNoAuthService.CompanyIdentityType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/fleet/constants/FormTypes.ts)} */
    var FieldName;
    (function (FieldName) {
        FieldName["COMPANY_NAME"] = "company_name";
        FieldName["FLEET_SIZE"] = "fleet_size";
        FieldName["CITY_ID"] = "city_id";
        FieldName["BILLING_TYPE"] = "billing_type";
        FieldName["PAYOUT_RECIPIENT_TYPE"] = "payout_recipient_type";
        FieldName["ADDRESS"] = "address";
        FieldName["REG_CODE"] = "reg_code";
        FieldName["IS_LIABLE_TO_VAT"] = "is_liable_to_vat";
        FieldName["VAT_CODE"] = "vat_code";
        FieldName["ACCOUNT_RECIPIENT"] = "account_recipient";
        FieldName["ACCOUNT_IBAN"] = "account_iban";
        FieldName["ACCOUNT_SWIFT"] = "account_swift";
        FieldName["TAX_IDENTIFICATION_NUMBER"] = "tax_identification_number";
        FieldName["TAX_IDENTIFICATION_NUMBER_COUNTRY"] = "tax_identification_number_country";
        FieldName["NEW_PASSWORD"] = "new_password";
        FieldName["CURRENT_PASSWORD"] = "current_password";
        FieldName["PHONE_NUMBER"] = "phone_number";
        FieldName["PHONE_COUNTRY_CODE"] = "phone_country_code";
        FieldName["EMAIL"] = "email";
        FieldName["EMAIL_OR_USERNAME"] = "email_or_username";
        FieldName["FIRST_NAME"] = "first_name";
        FieldName["LAST_NAME"] = "last_name";
    })(FieldName = FleetOwnerAuthNoAuthService.FieldName || (FleetOwnerAuthNoAuthService.FieldName = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/fleet/constants/FormTypes.ts)} */
    var FormFieldType;
    (function (FormFieldType) {
        FormFieldType["TEXT"] = "text_input";
        FormFieldType["NUMBER"] = "number_input";
        FormFieldType["COMBOBOX"] = "combo_box";
        FormFieldType["CHECKBOX"] = "check_box";
        FormFieldType["CHECKBOXGROUP"] = "check_box_group";
        FormFieldType["RADIOGROUP"] = "radio_group";
        FormFieldType["FILEUPLOAD"] = "file_upload";
        FormFieldType["IMAGEUPLOAD"] = "image_upload";
        FormFieldType["PASSWORD"] = "password";
        FormFieldType["EMAIL"] = "email";
        FormFieldType["INFOTEXT"] = "info_text";
        FormFieldType["INFOTEXTGROUP"] = "info_text_group";
    })(FormFieldType = FleetOwnerAuthNoAuthService.FormFieldType || (FleetOwnerAuthNoAuthService.FormFieldType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/fleet/constants/FormTypes.ts)} */
    var PasswordValidationType;
    (function (PasswordValidationType) {
        PasswordValidationType["PASSWORD_LENGTH"] = "password_length";
        PasswordValidationType["CONTAIN_UPPER_AND_LOWER_CASE_LETTERS"] = "contain_upper_and_lower_case_letters";
        PasswordValidationType["CONTAIN_NUMBERS"] = "contain_numbers";
    })(PasswordValidationType = FleetOwnerAuthNoAuthService.PasswordValidationType || (FleetOwnerAuthNoAuthService.PasswordValidationType = {}));
    /** Generated from: {@link [VerificationCodeTable.ts](https://github.com/bolteu/bolt-server/blob/1631399657191e25fd7125601e5a3f3ef49f372f/common/authentication/async/table/VerificationCodeTable.ts)} */
    var VerificationCodeChannel;
    (function (VerificationCodeChannel) {
        VerificationCodeChannel["SMS"] = "sms";
        VerificationCodeChannel["CALL"] = "call";
    })(VerificationCodeChannel = FleetOwnerAuthNoAuthService.VerificationCodeChannel || (FleetOwnerAuthNoAuthService.VerificationCodeChannel = {}));
})(FleetOwnerAuthNoAuthService || (FleetOwnerAuthNoAuthService = {}));
